import { UserManager, WebStorageStateStore } from "oidc-client-ts";
import React, { createContext, useContext, useMemo } from "react";
import { useRuntimeConfiguration } from "./runtimeConfigurationProvider";

export const UserManagerContext = createContext<UserManager | null>(null);

export const UserManagerProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const config = useRuntimeConfiguration();

  const userManager = useMemo(
    () =>
      new UserManager({
        authority: `${config.keycloakUrl}/realms/${config.keycloakRealm}`,
        client_id: config.keycloakClientId,
        redirect_uri: `${window.location.origin}/callback`,
        post_logout_redirect_uri: window.location.origin,
        userStore: new WebStorageStateStore({ store: window.sessionStorage }),
        monitorSession: config.env !== "local",
        automaticSilentRenew: true,
        silent_redirect_uri: `${window.location.origin}/silent-redirect.html`,
        silentRequestTimeoutInSeconds: 10,
      }),
    [config]
  );

  return <UserManagerContext.Provider value={userManager}>{children}</UserManagerContext.Provider>;
};

export const useUserManager = (): UserManager => {
  const context = useContext(UserManagerContext);
  if (!context) {
    throw new Error("useUserManager must be used within a UserManagerProvider");
  }
  return context;
};
